import { createAction } from '@reduxjs/toolkit';
import type { CommissionFormValues } from '@/components/~advisor/Trading/Trading/CustomCommissionModal';

export const saveCommissionState = createAction<CommissionFormValues>('trading/saveCommissionState');

export const clearCommissionState = createAction('trading/clearCommissionState');
